import React from 'react'
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft'

const LeftArrow = () => {
	return <KeyboardArrowLeftIcon />
}

export default LeftArrow
